const ACTIVE_SCAN_STATUSES = [
  'DISCOVERING',
  'SCANNING',
  'ANALYZING',
  'DIFFING',
] as const;

const TERMINAL_SCAN_STATUSES = ['STOPPED', 'COMPLETED', 'FAILED', 'IDLE'];

export function isScanStillRunning(scan: {
  status?: string | null;
  stages: Array<{ status: string }>;
}): boolean {
  if (scan.status != null && TERMINAL_SCAN_STATUSES.includes(scan.status)) {
    return false;
  }
  if (
    scan.status != null &&
    ACTIVE_SCAN_STATUSES.includes(
      scan.status as (typeof ACTIVE_SCAN_STATUSES)[number],
    )
  ) {
    return true;
  }
  return scan.stages.some((stage) => stage.status === 'started');
}
